const StoreTypes = {
    
    GET_STORE_TIMINGS:"GET_STORE_TIMINGS" ,
    GET_STORE_TIMINGS_SUCCESS:"GET_STORE_TIMINGS_SUCCESS"
};

export {StoreTypes};